export function displayOnlyLimitLength(str, limitLength) {
    const continueCharacters = '...';

    if (str.length <= limitLength) {
        return str;
    }

    const shortenString = str.substring(0, limitLength - continueCharacters.length);

    return shortenString + continueCharacters;
}

export const capitalize = (s) => {
    if (typeof s !== 'string') return '';

    return s.charAt(0).toUpperCase() + s.slice(1);
};
